import React, { useState } from "react";
import { CheckCircle2Icon, Loader2Icon } from "lucide-react";
const socials = [{
  label: "Instagram",
  href: "https://instagram.com"
}, {
  label: "TikTok",
  href: "https://tiktok.com"
}, {
  label: "Strava Club",
  href: "https://strava.com"
}, {
  label: "WhatsApp",
  href: "https://wa.me"
}];
type Status = "idle" | "loading" | "success" | "error";
export function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      return;
    }
    setStatus("loading");
    window.setTimeout(() => setStatus("success"), 800);
  };
  return <footer className="bg-espresso text-cream" data-id="element-146" data-mp="3qf9qwppyz0gu">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr] lg:py-20" data-id="element-147" data-mp="29y5hq2ysxow2">
        <div className="max-w-md" data-id="element-148" data-mp="2ez1lmgj5lb1h">
          <p className="text-xl font-semibold tracking-tight" data-id="element-149" data-mp="2evx8gtnpn4yo">Gabung di daftar komunitas</p>
          <p className="mt-2 text-sm leading-relaxed text-cream/70" data-id="element-150" data-mp="3lbmtfq7jj4eu">
            Dapatkan info pertama soal workshop, gowes bareng, dan game night. Satu email per
            minggu, tanpa spam.
          </p>
          {status === "success" ? <p className="mt-6 flex items-center gap-2 text-sm font-medium text-sage-light" role="status" data-id="element-151" data-mp="3q8dk17gz1iei">
              <CheckCircle2Icon className="h-5 w-5" data-id="element-152" data-mp="81yvkel2tq1v" /> Berhasil! Sampai jumpa di acara berikutnya.
            </p> : <form onSubmit={submit} className="mt-6" noValidate data-id="element-153" data-mp="33nlq3us7fjn">
              <label htmlFor="newsletter" className="sr-only" data-id="element-154" data-mp="ht3bbgiktexr">
                Alamat email
              </label>
              <div className="flex flex-col gap-2 sm:flex-row" data-id="element-155" data-mp="cv1smwp2bhmt">
                <input id="newsletter" type="email" value={email} onChange={e => {
              setEmail(e.target.value);
              if (status === "error") setStatus("idle");
            }} placeholder="kamu@email.com" aria-invalid={status === "error"} aria-describedby={status === "error" ? "newsletter-error" : undefined} className="w-full rounded-full border border-espresso-line bg-espresso-light px-5 py-3 text-sm text-cream placeholder:text-cream/40 focus:border-sage-light focus:outline-none" data-id="element-156" data-mp="qt8f7gok9v76" />
                <button type="submit" disabled={status === "loading"} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-sage px-6 py-3 text-sm font-semibold transition-[background-color,transform] duration-150 ease-out hover:bg-sage-dark active:scale-[0.97] disabled:opacity-70" data-id="element-157" data-mp="1hkp58htnrvcp">
                  {status === "loading" && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-158" data-mp="3t9q6204yxgsi" />}
                  Berlangganan
                </button>
              </div>
              {status === "error" && <p id="newsletter-error" className="mt-2 pl-5 text-xs text-[#E8A48A]" data-id="element-159" data-mp="25oexs0w4xofq">
                  Masukkan alamat email yang valid.
                </p>}
            </form>}
        </div>

        <div data-id="element-160" data-mp="1wo8oysbdtcmw">
          <p className="text-sm font-semibold" data-id="element-161" data-mp="1woryplqvoupu">Jam operasional</p>
          <ul className="mt-4 space-y-2 text-sm text-cream/70" data-id="element-162" data-mp="2tdznr3qphlyi">
            <li data-id="element-163" data-mp="2td6log2ozkmp">Setiap hari · 07.00–21.00</li>
            <li className="text-cream/50" data-id="element-164" data-mp="2pbuui6466rce">Berlaku di semua outlet</li>
          </ul>
        </div>

        <div data-id="element-165" data-mp="2kcrz7ddzrzhm">
          <p className="text-sm font-semibold" data-id="element-166" data-mp="2kci7nldatk9t">Ikuti kami</p>
          <ul className="mt-4 space-y-2 text-sm" data-id="element-167" data-mp="2kf4c3c4w7jnt">
            {socials.map(s => <li key={s.label} data-id="element-168" data-mp="2fgazdlxfjwop">
                <a href={s.href} target="_blank" rel="noreferrer" className="text-cream/70 transition-colors duration-150 hover:text-cream" data-id="element-169" data-mp="18ynvhfhlqwzd">
                  {s.label}
                </a>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-espresso-line" data-id="element-170" data-mp="2wnr1gqsogn40">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-xs text-cream/50 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-171" data-mp="2ivkvfxj8nwia">
          <p data-id="element-172" data-mp="2ns1lixa00ky0">© {new Date().getFullYear()} Kopi Lima Detik. Hak cipta dilindungi.</p>
          <p data-id="element-173" data-mp="3bk8c1ft1lxpi">Diseduh dengan sepenuh hati di Jakarta Selatan.</p>
        </div>
      </div>
    </footer>;
}